module.exports = __webpack_public_path__ + "static/media/menu.0b248c9f.svg";